import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t } = useTranslation('shareNote');

  return (
    <div className="mb-8">
      <div className="flex justify-center mb-6">
        <img src="/logo.svg" alt="Bitfortex" className="w-16 h-16" />
      </div>
      <h1 className="text-3xl font-bold text-gray-800">{t('title')}</h1>
      <p className="text-gray-600 mt-2">{t('subtitle')}</p>
    </div>
  );
}